import React from "react";
const Test = ()=>{
    return(
        <div className="test">
            test
        </div>
    );
}
export default Test;